// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { Button } from '../../../../components';
import CrossIcon from '../../../../images/cancel.svg';
import AcceptIcon from '../../../../images/success.svg';
import styles from './styles';
import Stepper from '../../../../components/Stepper/Stepper.js';

const CollectionStatus = (props) => {
  const {
    classes, onPress, status, orderIdFromAccountPage
  } = props;
  const icon = status ? AcceptIcon : CrossIcon;
  const text = status
    ? 'Thank you, we will be in touch shortly'
    : 'Error';
  const instructionTitleText = 'In the meantime you can go ahead and pack your items.';

  return (
    <div className={classes.container}>
      <img
        className={classes.statusIcon}
        src={icon}
        alt={'requestStatusIcon'}
      />
      <p className={classes.text}>
        {text}
      </p>
      {
        orderIdFromAccountPage
          ? null
          : (
            <Button
              style={classes.button}
              text={'GO TO MY ORDERS'}
              onPress={onPress}
            />
          )
      }
      { status && (
        <>
          <p className={classes.text}>
            <span>{instructionTitleText}</span>
          </p>
          <Stepper isTradeCustomer={false} isArrangeCollection={true} />

        </>
      )}
    </div>
  );
};

CollectionStatus.propTypes = {
  classes: PropTypes.object,
  onPress: PropTypes.func,
  status: PropTypes.bool,
  orderIdFromAccountPage: PropTypes.bool,
};

CollectionStatus.defaultProps = {
  classes: {},
  onPress: () => { },
  status: false,
  orderIdFromAccountPage: false,
};

export default withStyles(styles)(CollectionStatus);
